import { render, staticRenderFns } from "./FeatureCardZdmLamp.vue?vue&type=template&id=19cdbe46&scoped=true&"
import script from "./FeatureCardZdmLamp.vue?vue&type=script&lang=js&"
export * from "./FeatureCardZdmLamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdbe46",
  null
  
)

export default component.exports